module.exports = __webpack_public_path__ + "img/rafiki.dbc9b7c3.png";